/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react'
import { useOutletContext } from 'react-router-dom'
import TabWithSubNav from '../../../../TabWithSubNav'
import CampaignsSection from './CampaignsSection'
import CredentialsSection from './CredentialsSection'
import OAuthSection from './OAuthSection'
import RedirectsSection from './RedirectsSection'
import LoginSection from './LoginSection'

export function DeployTab() {
  const { verificationListing: listing } = useOutletContext()
  if (!listing) {
    return null
  }
  return (
    <TabWithSubNav
      items={
    [
      { primaryText: 'OAuth Links', component: <OAuthSection listing={listing} /> },
      { primaryText: 'Campaigns', component: <CampaignsSection listing={listing} /> },
      { primaryText: 'Whitelisted URLs', component: <RedirectsSection listing={listing} /> },
      { primaryText: 'Credentials', component: <CredentialsSection listing={listing} /> },
      { primaryText: 'GOVX Login', component: <LoginSection listing={listing} /> },
    ]
  }
    />
  )
}

export default DeployTab
